/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, withAssign } from '@reatom/framework'

import { AuthState } from '../model'

import type { User } from '../model'

export const reatomAuthState = () => {
  const stateAtom = atom(AuthState.initial(), 'stateAtom')

  // #region Computed

  const delugeIdAtom = atom((ctx) => {
    const state = ctx.spy(stateAtom)
    if (AuthState.isLoggedIn(state)) {
      return ctx.spy(state.user).delugeId
    }
    return undefined
  }, 'delugeIdAtom')

  const isLoggedInAtom = atom((ctx) => {
    const state = ctx.spy(stateAtom)
    return AuthState.isLoggedIn(state)
  }, 'isLoggedInAtom')

  const userAtom = atom((ctx) => {
    const state = ctx.spy(stateAtom)
    if (AuthState.isLoggedIn(state)) {
      return ctx.spy(state.user)
    }
    return undefined
  }, 'userAtom')

  // #endregion

  // #region Actions
  const setLoggedInAction = action((ctx, user: User.User) => {
    const currentState = ctx.get(stateAtom)
    if (AuthState.isLoggedIn(currentState)) {
      return
    }
    stateAtom(ctx, { type: 'LoggedIn', user: atom(user) })
  })
  const setInitialAction = action((ctx) => {
    stateAtom(ctx, { type: 'Initial' })
  })
  const setSessionExpiredAction = action((ctx) => {
    const state = ctx.get(stateAtom)
    if (AuthState.isLoggedIn(state)) {
      stateAtom(ctx, { type: 'SessionExpired', user: ctx.get(state.user) })
      return
    }
  })
  const updateUserOrSetLoggedInAction = action((ctx, user: User.User) => {
    const state = ctx.get(stateAtom)
    if (AuthState.isLoggedIn(state)) {
      state.user(ctx, user)
      return
    }
    setLoggedInAction(ctx, user)
  })
  // #endregion

  return stateAtom.pipe(
    withAssign(() => ({
      delugeId: delugeIdAtom,
      isLoggedIn: isLoggedInAtom,
      user: userAtom,
      setInitial: setInitialAction,
      setLoggedIn: setLoggedInAction,
      setSessionExpired: setSessionExpiredAction,
      updateUserOrSetLoggedIn: updateUserOrSetLoggedInAction,
    })),
  )
}

export const authStateAtom = reatomAuthState()
